/**
 * Created by: cparaschiv
 * Date: 03.04.2013, 12:47
 */

(function($) {

    var ui = kendo.ui,
        Selectable = ui.Selectable,
        ARIASELECTED = "aria-selected",
        SELECTED = "k-state-selected",
        ACTIVE = "k-state-selecting",
        SELECTABLE = "k-selectable",
        CHANGE = "change",
        UNSELECTING = "k-state-unselecting";


    var TsSelectable = Selectable.extend({

        init: function(element, options) {

            Selectable.fn.init.call(this, element, options);
        },

        _deselectElement: function(element, preventNotify) {
            var toSelect = $(element),
                isPrevented =  !preventNotify && this._notify("deselect", { element: element });

            toSelect.removeClass(ACTIVE);
            if(!isPrevented) {
                 toSelect.removeClass(SELECTED);

                if (this.options.aria) {
                    toSelect.attr(ARIASELECTED, false);
                }
            }
        },

        deselect: function(val) {
            var that = this,
                deselectElement = $.proxy(that._deselectElement, that);

            if(val) {
                val.each(function() {
                    deselectElement(this);
                });

                that._notify(CHANGE);
                return;
            }

            return null;
        },

        _start: function(e) {
            var that = this,
                target = $(e.target),
                selected = target.hasClass(SELECTED),
                ctrlKey = e.event.ctrlKey || e.event.metaKey;

            that._downTarget = target;

            //in case of hierarchy
            if (target.closest("." + SELECTABLE)[0] !== that.element[0]) {
                that.userEvents.cancel();
                that._downTarget = null;
                return;
            }

            // CP 20140303 - don't draw marquee
//            that._marquee
//                .appendTo(document.body)
//                .css({
//                    left: e.x.client + 1,
//                    top: e.y.client + 1,
//                    width: 0,
//                    height: 0
//                });

            if (!ctrlKey) {
                that.clear();
            }

            if (selected) {
                that._selectElement(target, true);
                if (ctrlKey) {
                    target.addClass(UNSELECTING);
                }
            }
        },

        _move: $.noop,

        _select: function(e) {
            var selector = "input,a,textarea,.k-multiselect-wrap,select",
                msie = kendo.support.browser.msie;
            if ($(e.event.target).is(selector)) {
                this.userEvents.cancel();
                this._downTarget = null;
            } else if (!msie || (msie && !$(kendo._activeElement()).is(selector))) {
                // CP 20140303 - allow user to select grid cell text
                //e.preventDefault();
            }
        },

        options: {
             name: "Selectable" //overwrite kendo's Selectable plugin
        }

    });

    TsSelectable.parseOptions = Selectable.parseOptions;
    ui.plugin(TsSelectable);

})(jQuery);
